export default "__VITE_ASSET__c2a82990__"